import L from "leaflet";

const sections = document.querySelectorAll(".map");

if (sections.length > 0) {

    const createPopupHtml = (address, imageArray) => {
        let string = "";
        let image = null;

        if (imageArray) {
            const {title, url, alt} = imageArray;
            image = `<img src="${url}" alt="${alt}" title="${title}" class="map__popup-image"/>`;
        }

        string = `
        <div class="map__popup">
            ${image ? image : ""}
            <div class="map__popup-address">
                ${address}
            </div>
        </div>`;

        return string;

    }

    sections.forEach(section => {
        const mapElement = section.querySelector(".map__map-element");
        const settings = JSON.parse(mapElement.getAttribute("data-settings"));
        const {lat, lng, image, address} = settings;

        if (!lat || !lng) return;

        const map = L.map(mapElement, {
            center: L.latLng(lat, lng),
            zoom: 16,
            zoomControl: false,
        });
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(map);
        if (!address) return;
        const marker = L.marker([lat, lng], {
            opacity: 0,
        }).addTo(map);
        const mapString = createPopupHtml(address, image);

        map.on("popupopen", (event) => {
            const popupPixelCoords = map.project(event.popup.getLatLng());
            const popupHeight = event.popup.getElement().clientHeight;
            popupPixelCoords.y -= popupHeight / 2; // move the popup vertical axis location down (distance: half of popup height)
            map.panTo(map.unproject(popupPixelCoords), { animate: true }); // pan to calculated location
        });

        marker.bindPopup(mapString, {
            autoClose: false,
            closeOnClick: false,
        }).openPopup();
    });
}
